// extracted by mini-css-extract-plugin
export default {"mainHolder":"TutorReordering_mainHolder__BwxBU","rowHolder":"TutorReordering_rowHolder__6wAv1"};